import { Component } from '@angular/core';

@Component({
  selector: 'cards-items',
  templateUrl: './cards.component.html',
  styleUrls: ['./cards.component.scss'],
})
export class CardSectionComponent {
}
